import { SelectOption } from '@Components/Selectors/Select'
import { OptionModel } from '@Entities/lib'

export const formatLanguage = (langOptions: OptionModel[], langCode: number | null) =>
    langOptions.find((lang: SelectOption) => +lang.id === langCode)?.label
